//match this with SuccessWebsiteAPI\Billing\Enums\PackageFeatures.cs
export enum PackageFeatures {
    ActionsPlans,
    Ai,
    UnlimitedCalls,
    /// <summary>
    /// "aka Unlimited14"
    /// </summary>
    UnlimitedNudges,
}
